export default {
  data() {
    return {
      fallbackImageUrl: require('@/static/img/product-alternate-image.png')
    };
  },
  methods: {
    getImageUrl(url) {
      return url || this.fallbackImageUrl;
    },
    handleImageError(event) {
      if (event.target.src !== this.fallbackImageUrl) {
        event.target.src = this.fallbackImageUrl;
      }
    }
  }
};
